<div class="manage-duplicates-headers">
  <div class="page-title">Manage Duplicate Businesses</div>
  @if (total > 0) {
    <div class="page-size">
      <app-page-size
        [pageSize]="pageSize"
        [selectId]="'duplicate-page-size'"
        (pageSizeChanged)="onPageSizeChange($event)"
      ></app-page-size>
    </div>
  }
</div>

<!-- Dashboard Stat Cards -->
<div class="dashboard-container">
  @if (isSummaryLoading) {
    <div class="stats-grid">
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
      <div class="skeleton-box"></div>
    </div>
  } @else {
    <div class="stats-grid">
      <!-- Email Duplicates Card -->
      <div
        class="stat-card email-card"
        [class.active]="identityTypeFilter === 'email'"
        (click)="onCategoryTabChange('email')"
        (keydown.enter)="onCategoryTabChange('email')"
        role="button"
        tabindex="0"
      >
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
            fill="currentColor"
          />
        </svg>
        <div class="stat-content">
          <h3>Email Duplicates</h3>
          <div class="stat-value">
            {{ summary.email_duplicate_groups }}
          </div>
        </div>
      </div>

      <!-- Business Name Duplicates Card -->
      <div
        class="stat-card complete-card"
        [class.active]="identityTypeFilter === 'name'"
        (click)="onCategoryTabChange('name')"
        (keydown.enter)="onCategoryTabChange('name')"
        role="button"
        tabindex="0"
      >
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
          />
        </svg>
        <div class="stat-content">
          <h3>Business Name Duplicates</h3>
          <div class="stat-value">
            {{ summary.name_duplicate_groups }}
          </div>
        </div>
      </div>

      <!-- Phone Duplicates Card -->
      <div
        class="stat-card rate-card"
        [class.active]="identityTypeFilter === 'phone'"
        (click)="onCategoryTabChange('phone')"
        (keydown.enter)="onCategoryTabChange('phone')"
        role="button"
        tabindex="0"
      >
        <svg
          class="stat-icon"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
          />
        </svg>
        <div class="stat-content">
          <h3>Phone Duplicates</h3>
          <div class="stat-value">
            {{ summary.phone_duplicate_groups }}
          </div>
        </div>
      </div>
    </div>
  }
</div>

<!-- Filter & Search Bar -->
<div class="filter-search-section">
  <div class="search-section-wrapper">
    <app-search-input
      [placeholder]="'Search identity value ...'"
      [(searchQuery)]="search"
      (searchQueryChange)="onSearchQueryChange($event)"
    ></app-search-input>
  </div>
  @if (total > 0) {
    <div class="total-badge">
      Showing <strong>{{ identities.length }}</strong> of
      <strong>{{ total }}</strong> duplicate groups
    </div>
  }
</div>

<!-- Skeleton Loader State for Groups -->
@if (isLoading) {
  <div class="skeleton-list">
    <div class="skeleton-card" *ngFor="let item of [1, 2, 3]">
      <div class="skeleton-bar title"></div>
      <div class="skeleton-bar count"></div>
    </div>
  </div>
}

<!-- Identities List -->
@if (!isLoading) {
  <div class="identity-list">
    @for (group of identities; track group.id) {
      <div
        class="identity-card"
        [class.expanded]="expandedIdentityId === group.id"
      >
        <div
          class="identity-header"
          (click)="toggleExpand(group)"
          (keydown.enter)="toggleExpand(group)"
          role="button"
          tabindex="0"
        >
          <div class="identity-meta">
            <span class="type-badge" [class]="group.identity_type">
              {{ group.identity_label }}
            </span>
            <span class="identity-value">{{ group.identity_value }}</span>
            <span class="match-pill"
              >{{ group.match_count }} records matched</span
            >
          </div>
          <div class="identity-actions">
            <button
              class="btn-chevron"
              [class.rotated]="expandedIdentityId === group.id"
              aria-label="Toggle details"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
          </div>
        </div>

        <!-- Member Business Records Table (Expanded Drawer with Progressive Lazy Loading) -->
        @if (expandedIdentityId === group.id) {
          <app-manage-duplicate-items
            [group]="group"
            (viewDetails)="viewRecordDetails($event)"
          ></app-manage-duplicate-items>
        }
      </div>
    }

    <!-- Empty State -->
    @if (identities.length === 0) {
      <div class="no-identities-box">
        <div class="empty-icon">
          <svg
            width="36"
            height="36"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </div>
        <h3>No Duplicate Groups Found</h3>
        <p>
          No business record duplicate clusters matched your current filter
          criteria.
        </p>
      </div>
    }
  </div>
}

<!-- Main Groups Pagination Component -->
@if (!isLoading && total > pageSize) {
  <div class="pagination-wrapper">
    <app-pagination
      [currentPage]="page"
      [pageSize]="pageSize"
      [totalItems]="total"
      (pageChanged)="onPageChange($event)"
    ></app-pagination>
  </div>
}

<!-- Shared Record Details Popup -->
@if (showRecordDetails) {
  <app-record-details
    [unique_id]="selectedUniqueId"
    (popupClosed)="showRecordDetails = false"
  ></app-record-details>
}
